export default __webpack_public_path__ + "static/media/news2.b8fe20f2.mp4";